module.exports = __webpack_public_path__ + "img/audio_classify8.0f353193.svg";